import { useState, useEffect } from 'react'
import { useFetch } from '../hooks/useFetch'
import { productService } from '../services/product.service'
import Layout from '../components/Layout/Layout'
import HeroCarousel from '../components/Carousel/HeroCarousel'
import ProductCarousel from '../components/Carousel/ProductCarousel'

const Home = () => {
  const [heroSlides, setHeroSlides] = useState([])
    
  // Fetch random products for carousels
  const { 
    data: randomProducts, 
    loading: randomLoading, 
    error: randomError 
  } = useFetch(() => productService.getRandomProducts(6))
    
  // Hero slides configuration
  useEffect(() => {
    const slides = [
      {
        id: 1,
        image: '/images/hero/reinas.jpg',
        title: 'CORONAS DE REINA',
        cta: 'Saber más',
        ctaLink: '/categoria/Coronas de Reina'
      },
      {
        id: 2,
        image: '/images/hero/xv.jpg',
        title: 'CORONAS DE XV AÑOS',
        cta: 'Saber más',
        ctaLink: '/categoria/Coronas'
      }
    ]
    setHeroSlides(slides)
  }, [])
    
  return (
    <Layout>
      {/* Hero Section */}
      <section className="relative">
        <HeroCarousel 
          slides={heroSlides} 
          autoPlay={true} 
          interval={6000} 
        />
      </section>
            
      {/* Random Products Carousel */}
      <section className="py-12 sm:py-16 bg-white">
        <div className="container mx-auto px-4 pb-8 overflow-hidden">
          {randomProducts && randomProducts.data.length > 0 ? (
            <ProductCarousel
              products={randomProducts.data}
              title="LO MÁS VENDIDO"
              showExploreButton={true}
            />
          ) : (
            randomLoading ? (
              <div>
                <h2 className="text-2xl sm:text-3xl font-title font-semibold text-primary-text mb-8 text-center">
                  LO MÁS VENDIDO
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
                  {Array.from({ length: 3 }).map((_, index) => (
                    <div key={index} className="animate-pulse">
                      <div className="aspect-square bg-gray-200 rounded-lg mb-3"></div>
                      <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
                      <div className="h-3 bg-gray-200 rounded w-1/2"></div>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <div>Error: {randomError}</div>
            )
          )}
        </div>
      </section>
            
      {/* Invite Section */}
      <section className="bg-primary-light">
        <div className="flex flex-col lg:flex-row items-center min-h-[400px] lg:min-h-[500px]">
          {/* Imagen - Izquierda en desktop, arriba en móvil */}
          <div className="w-full lg:w-1/2 mb-8 lg:mb-0">
            <div className="relative aspect-square overflow-hidden">
              <img 
                src="/images/home/realeza.jpg" 
                alt="Destellos de Realeza"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
          <div className="w-full lg:w-1/2">
            <div className="flex items-center justify-center h-full text-center lg:text-left">
              <div className="max-w-lg text-center">
                <h2 className="text-3xl lg:text-4xl font-title font-semibold text-primary-black mb-6">
                  DESTELLOS DE REALEZA
                </h2>
                <p className="text-lg text-primary-text mb-8 leading-snug font-body font-light">
                  Brilla con exclusividad en tu día especial. Cada set refleja estilo, calidad y arte, pensado para resaltar tu elegancia con un toque de distinción.
                </p>
                <a
                  href="/categoria/Coronas de Reina"
                  className="inline-block text-primary-black hover:text-primary-black/50 transition-all duration-300 font-medium text-lg font-body"
                >
                  Explorar colección
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default Home